<template>
  <div class="agricultural-subsidy-data-tab">
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="种粮大户补贴" name="majorGrainGrower">
        <el-table :data="majorGrainGrowerData" style="width: 100%">
          <el-table-column prop="subsidyYear" label="补贴年度" width="200" align="center" />
          <el-table-column prop="subsidyArea" label="补贴面积（亩）" width="200" align="center" />
          <el-table-column prop="subsidyAmount" label="补贴金额（元）" width="200" align="center" />
          <el-table-column prop="grantStatus" label="发放状态" align="center" />
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="农机购置补贴" name="machinePurchase">
        <el-table :data="machinePurchaseData" style="width: 100%">
          <el-table-column prop="buyerName" label="购机者姓名" width="100" align="center" />
          <el-table-column prop="machineCategory" label="机具品目" width="100" align="center" />
          <el-table-column prop="manufacturer" label="生产厂家" width="150" align="center" />
          <el-table-column prop="productName" label="产品名称" width="120" align="center" />
          <el-table-column prop="machineModel" label="购买机型" width="100" align="center" />
          <el-table-column
            prop="purchaseQuantity"
            label="购买数量（台）"
            width="130"
            align="center"
          />
          <el-table-column prop="purchaseDate" label="购买日期" width="120" align="center" />
          <el-table-column
            prop="singlePrice"
            label="单台销售价格（元）"
            width="150"
            align="center"
          />
          <el-table-column prop="subsidyAmount" label="总补贴额（元）" width="130" align="center" />
          <el-table-column prop="factoryNumber" label="出厂编号" width="100" align="center" />
          <el-table-column prop="status" label="状态" width="100" align="center" />
          <el-table-column prop="isOverRecord" label="是否超录申请" width="150" align="center" />
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="社会化服务补贴" name="socialService">
        <el-table :data="socialServiceData" style="width: 100%">
          <el-table-column prop="subsidyYear" label="补贴年度" width="200" align="center" />
          <el-table-column prop="subsidyArea" label="补贴面积（亩）" width="200" align="center" />
          <el-table-column prop="subsidyAmount" label="补贴金额（元）" width="200" align="center" />
          <el-table-column prop="grantStatus" label="发放状态" align="center" />
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'AgriculturalSubsidyDataTab',
  props: {
    majorGrainGrowerInfoList: {
      type: Array,
      default: () => []
    },
    machinePurchaseInfoList: {
      type: Array,
      default: () => []
    },
    socialServiceInfoList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeTab: 'majorGrainGrower',
      _majorGrainGrowerData: [
        {
          subsidyYear: '2024',
          subsidyArea: '1000',
          subsidyAmount: '5000',
          grantStatus: '已发放'
        },
        {
          subsidyYear: '2024',
          subsidyArea: '800',
          subsidyAmount: '4000',
          grantStatus: '待发放'
        }
      ],
      _machinePurchaseData: [
        {
          buyerName: '张三',
          machineCategory: '拖拉机',
          manufacturer: '中国拖拉机有限公司',
          productName: '拖拉机A100',
          machineModel: 'A100-2024',
          purchaseQuantity: '2',
          purchaseDate: '2024-04-01',
          singlePrice: '10000',
          subsidyAmount: '20000',
          factoryNumber: '123456789012345678',
          status: '已发放',
          isOverRecord: '否'
        }
      ],
      _socialServiceData: [
        {
          subsidyYear: '2024',
          subsidyArea: '1000',
          subsidyAmount: '5000',
          grantStatus: '已发放'
        },
        {
          subsidyYear: '2024',
          subsidyArea: '800',
          subsidyAmount: '4000',
          grantStatus: '待发放'
        }
      ]
    }
  },
  computed: {
    majorGrainGrowerData() {
      return this.mapToMajorGrainGrowerData(this.majorGrainGrowerInfoList)
    },
    machinePurchaseData() {
      return this.mapToMachinePurchaseData(this.machinePurchaseInfoList)
    },
    socialServiceData() {
      return this.mapToSocialServiceData(this.socialServiceInfoList)
    }
  },
  methods: {
    handleTabClick(tab) {
      this.activeTab = tab.name
    },

    mapToMajorGrainGrowerData(data) {
      return data.map(item => ({
        subsidyYear: item.year || '',
        subsidyArea: item.area || '',
        subsidyAmount: item.amount || '',
        grantStatus: item.status || ''
      }))
    },
    mapToMachinePurchaseData(data) {
      return data.map(item => ({
        buyerName: item.owner || '',
        machineCategory: item.category || '',
        manufacturer: item.manufacturer || '',
        productName: item.productName || '',
        machineModel: item.model || '',
        purchaseQuantity: item.count || '',
        purchaseDate: item.buyTime || '',
        singlePrice: item.unitSellPrice || '',
        subsidyAmount: item.totalSubsidy || '',
        factoryNumber: item.code || '',
        status: item.status || '',
        isOverRecord: item.isApply || ''
      }))
    },
    mapToSocialServiceData(data) {
      return data.map(item => ({
        subsidyYear: item.year || '',
        subsidyArea: item.area || '',
        subsidyAmount: item.amount || '',
        grantStatus: item.status || ''
      }))
    }
  }
}
</script>

<style lang="less" scoped>
.agricultural-subsidy-data-tab {
  background-color: #f5f5f5;

  .el-tabs {
    background: white;

    /deep/ .el-tabs__header {
      margin-bottom: 20px;
    }

    /deep/ .el-tabs__nav-wrap {
      &::after {
        display: none;
      }
    }

    /deep/ .el-tabs__active-bar {
      background-color: #409eff;
      height: 2px;
    }

    /deep/ .el-tabs__item {
      &.is-active {
        color: #409eff;
        font-weight: bold;
      }

      &:hover {
        color: #409eff;
      }
    }
  }

  .el-table {
    margin-bottom: 20px;

    /deep/ .el-table__header {
      background-color: #fafafa;
    }
  }

  .pagination-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }

  .text-muted {
    color: #999;
  }

  .statistics-container {
    padding: 20px 0;

    .statistics-card {
      margin-bottom: 20px;
      border: none;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .statistics-item {
        display: flex;
        align-items: center;
        padding: 10px 0;

        .statistics-icon {
          font-size: 32px;
          color: #409eff;
          margin-right: 15px;
        }

        .statistics-content {
          .statistics-title {
            font-size: 14px;
            color: #666;
            margin-bottom: 5px;
          }

          .statistics-value {
            font-size: 24px;
            font-weight: bold;
            color: #333;
          }
        }
      }
    }
  }
}
</style>
